import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "documents" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "white__navbar" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Доверенности")
], -1)
const _hoisted_3 = { class: "documents__content" }
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "data" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"color":"rgba(0, 0, 0, 0.4509803922)"} }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " № "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Дата выдачи "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Юридическое лицо "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Заявитель "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left",
      style: {"width":"62px"}
    }, " Операции ")
  ])
], -1)
const _hoisted_7 = { style: {"text-align":"left"} }
const _hoisted_8 = { style: {"width":"62px"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  style: {"position":"absolute","width":"200px","margin-left":"-180px","margin-top":"-35px","z-index":"1","text-align":"center","background":"white","-webkit-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none","box-shadow":"0px 20px 22px 0px #B2BDE169"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_Dots = _resolveComponent("Dots")!
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_vue_awesome_paginate = _resolveComponent("vue-awesome-paginate")!
  const _component_ModalDel = _resolveComponent("ModalDel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createProxy && _ctx.createProxy(...args))),
            style: {"width":"210px"}
          }, [
            _createVNode(_component_PlusIcon),
            _createTextVNode(" Новая доверенность")
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Поиск",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search_value) = $event))
          }, null, 512), [
            [_vModelText, _ctx.search_value]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_table, { "fixed-header": "" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("tbody", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proxies_lists, (input, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(input.id), 1),
                    _createElementVNode("td", null, _toDisplayString(input.date), 1),
                    _createElementVNode("td", null, _toDisplayString(input.client_name), 1),
                    _createElementVNode("td", null, _toDisplayString(input.declarer), 1),
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", {
                        class: "dots",
                        onClick: ($event: any) => (_ctx.context_detail=input.id)
                      }, [
                        _createVNode(_component_Dots)
                      ], 8, _hoisted_9),
                      (_ctx.context_detail==input.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.context_detail=0)),
                              style: {"text-align":"right"}
                            }, [
                              _createVNode(_component_LogoutIcon, { style: {"cursor":"pointer"} })
                            ]),
                            _createElementVNode("div", {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.open_doc(input.id))
                            }, "Просмотреть доверенность", 8, _hoisted_11),
                            _createElementVNode("div", {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.save_doc(input.id))
                            }, "Скачать доверенность", 8, _hoisted_12),
                            _createElementVNode("div", {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.hide_doc_modal(input.id))
                            }, "Удалить доверенность", 8, _hoisted_13)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_vue_awesome_paginate, {
        "total-items": _ctx.proxies_list.length,
        "items-per-page": _ctx.pages_on_page,
        "max-pages-shown": 17,
        modelValue: _ctx.page,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
        "prev-button-content": "Назад",
        "next-button-content": "Далее",
        style: _normalizeStyle(
		'position: relative; float: left; transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1); margin-top: -0.5rem; top: 0px; left: 0px; margin-left: 1.5rem;'
		//'top: '+screen_h+'px;'
	)
      }, null, 8, ["total-items", "items-per-page", "modelValue", "style"])
    ]),
    (_openBlock(), _createBlock(_component_ModalDel, {
      key: _ctx.del_key,
      is_open: _ctx.del_modal,
      info_txt: 'доверенность №',
      info_num: _ctx.del_num,
      onDo_btn: _ctx.hide_doc
    }, null, 8, ["is_open", "info_num", "onDo_btn"]))
  ], 64))
}